import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import Logo from "../../assets/new-logo.png";
import "./LoadingScreen.css";

export default function LoadingScreen({ targetPath = '/' }) {
  const [isLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const loadSuggestions = async () => {
      const timer = setTimeout(() => {
        navigate(targetPath);
      }, 1000);

      return () => clearTimeout(timer);
    };
    loadSuggestions();
  }, [navigate, targetPath]);

  return (
    <div className={`loading-screen ${!isLoading ? "slide-up" : ""}`}>
      <div className="loading-content">
        <img src={Logo} alt="SWP Logo" className="loading-logo" />
      </div>
    </div>
  );
}
